import {
  APIKey,
  Channel,
  DomainAPI,
  generateKey,
  _pick,
} from "../utils/setting";

const activeCode = {
  state: {},
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    },
  },
  effects: {
    createCodeRegisterForFree(payload = {}, rootState) {
      const _this = this;
      return fetch(
        DomainAPI +
          Channel +
          "/api/public/activeCode/createCodeRegisterForFree",
        {
          method: "POST",
          headers: {
            [APIKey]: generateKey(),
            "Content-type": "application/json",
          },
          body: JSON.stringify(payload.spa),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          if (result.code === 1) {
            return { code: 1, data: result.data };
          } else {
            if (payload.snackbar)
              payload.snackbar(result.message || "Something went wrong");
            return { code: 0, error: result.error, message: result.message };
          }
        })
        .catch((err) => {
          if (payload.snackbar)
            payload.snackbar(err.message || "Something went wrong");
          return false;
        });
    },
    createForgetPassword(payload, rootState) {
      const _this = this;
      return fetch(
        DomainAPI + Channel + "/api/public/activeCode/createForgetPassword",
        {
          method: "POST",
          body: JSON.stringify(_pick(payload, ["username", "countryCode"])),
          headers: {
            "Content-Type": "application/json",
            [APIKey]: generateKey(),
          },
        }
      )
        .then((res) => res.json())
        .then(function (result) {
          if (
            result &&
            result.code === 1 &&
            result.data &&
            result.data.expired
          ) {
            _this.setState({ expired: result.data.expired });
          }

          return result;
        })
        .catch((err) => {
          return {
            code: false,
            message: err.message,
            error: err,
          };
        });
    },
    checkActiveCode(payload, rootState) {
      return fetch(
        DomainAPI + Channel + "/api/public/activeCode/checkActiveCode",
        {
          method: "POST",
          body: JSON.stringify(
            _pick(payload, [
              "username",
              "countryCode",
              "activeCode",
              "eventType",
            ])
          ),
          headers: {
            "Content-Type": "application/json",
            [APIKey]: generateKey(),
            // [Authorization]: rootState.user.token
          },
        }
      )
        .then((res) => res.json())
        .then(function (result) {
          if (result.error) {
            if (result.error === 1117) {
              if (payload.snackbar && payload.t)
                payload.snackbar(
                  payload.t("activecode_is_incorrect_please_try_again")
                );
            } else if (result.error === 1116) {
              if (payload.snackbar && payload.t)
                payload.snackbar(
                  payload.t("activecode_is_expired_please_register_again")
                );
            } else {
              if (payload.snackbar)
                payload.snackbar(result.message || "Something went wrong");
            }
          }
          return result;
        })
        .catch((err) => {
          return {
            code: false,
            message: err.message,
            error: err,
          };
        });
    },
  },
};

export default activeCode;
